<template>
  <div class="pretty-select">
    <button type="button" class="flex dimensions-button" @click="toggleOptions">
      {{ getActualDimensionName }}
      <Icon icon="bootstrap-caret-down-fill" :width="9" :height="9" />
    </button>
    <ul v-if="showOptions" v-click-outside="closeOptions">
      <li
        v-for="(item, index) in options"
        :key="index"
        :class="{
          selected: getExperience && getActualDimensionName == item.name
        }"
        @click="makeSearch(item)"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Icon from 'UI/Icon';
import { gaEventSearchBanner } from '~/utils/common.js';

export default {
  components: {
    Icon
  },
  props: {
    isSearch: {
      type: Boolean,
      default: false
    },
    isBanner: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      showOptions: false
    };
  },
  computed: {
    ...mapGetters('experience', [
      'getExperience',
      'getSearchBarExperiences',
      'getDesign',
      'getMerch'
    ]),
    ...mapGetters('dimensions', [
      'getActualDimensionName',
      'getFilterDimensionsByExperience',
      'getDimensionAll',
      'getDimensionByName'
    ]),
    ...mapGetters('searchBar', ['getActualSearch']),
    experiences() {
      return [
        { name: 'All', experience: '' },
        { ...this.getSearchBarExperiences[0], experience: this.getDesign },
        { ...this.getSearchBarExperiences[1], experience: this.getMerch }
      ];
    },
    options() {
      return !this.getExperience
        ? this.experiences
        : this.getFilterDimensionsByExperience(this.getExperience);
    }
  },
  methods: {
    async makeSearch({ name: dimension, experience }) {
      gaEventSearchBanner(
        this.isBanner,
        this.getExperience,
        this.$ga.event,
        this.$route.fullPath,
        'Click Search Bar Filter Top Menu'
      );
      this.closeOptions();
      if (!this.getExperience) {
        if (experience != this.getExperience) {
          dimension = this.getDimensionAll;
        }
      } else {
        if (dimension != this.getActualDimensionName) {
          this.$store.dispatch('dimensions/ACTUAL_DIMENSION', dimension);
        }
      }

      this.$router.push({
        path: this.$urlBuilder('search', {
          path: this.getDimensionByName(dimension, experience).path,
          keyword: this.getActualSearch
        })
      });
    },
    closeOptions() {
      this.showOptions = false;
    },
    toggleOptions() {
      this.showOptions = !this.showOptions;
    }
  }
};
</script>

<style lang="scss" scoped>
.pretty-select {
  display: inline-block;
  height: 20px !important;
  margin: 0px 5px 0px 20px;
  border-right: 1px solid #dfdedc;
  padding-right: 15px;
  min-width: max-content;
  width: auto;
  position: relative;
}
.dimensions-button {
  min-width: max-content;
  min-width: -moz-max-content;
  white-space: nowrap;
  padding: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  display: block;
  font-size: 14px;
  color: #757575;
}
.dimensions-button .svg-icon-container {
  font-size: 8px;
  margin-left: 7px;
  margin-bottom: 2px;
}
.pretty-select > ul {
  height: auto;
  margin: 0;
  margin-top: 18px;
  padding: 0px;
  background-color: #ffffff;
  min-width: 110px;
  width: max-content;
  -webkit-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.3);
  position: absolute;
  z-index: 2;
  text-align: left;
  left: -5px;
  border-radius: 15px;
}
.pretty-select > ul.show {
  display: block;
}
.pretty-select > ul > li {
  width: 100%;
  padding: 8px 15px;
  z-index: 2;
  list-style: none;
  min-width: max-content;
  font-size: 13px;
  color: gray;
  cursor: pointer;
  &:first-child {
    padding-top: 10px;
  }
  &:last-child {
    padding-bottom: 12px;
  }
}
.pretty-select > ul > li::first-letter,
.pretty-select > .dimensions-button::first-letter {
  text-transform: uppercase;
}
.pretty-select > ul > li:hover,
ul li.selected {
  background-color: $lightGray;
  &:first-child {
    border-radius: 15px 15px 0 0;
  }
  &:last-child {
    border-radius: 0 0 15px 15px;
  }
}
.dimensions-button:focus {
  outline: none;
}
.pretty-select > ul > li.init {
  cursor: pointer;
}
</style>
